import { filterPrograms } from "@/lib/screenWalkthrough";

/** Iter 47 — program search + list. Selecting a program loads its walkthrough. */
export default function ProgramPicker({ programs, query, onQuery, selected, onSelect }) {
  const visible = filterPrograms(programs, query);
  return (
    <div className="ml-card p-3 space-y-2" data-testid="sw-program-picker">
      <div className="ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-text-secondary)]">Programs with observed screens ({(programs || []).length})</div>
      <input
        type="text"
        value={query || ""}
        onChange={(e) => onQuery(e.target.value)}
        placeholder="Search program or display file…"
        data-testid="sw-program-search"
        className="ml-mono text-xs w-full px-2 py-1.5 border border-[var(--ml-border)] uppercase"
      />
      {visible.length === 0 ? (
        <p className="text-xs text-[var(--ml-text-secondary)]" data-testid="sw-program-empty">
          {(programs || []).length === 0 ? "No program has an observed screen statement yet." : "No program matches."}
        </p>
      ) : (
        <ul className="divide-y divide-[var(--ml-border)] max-h-[60vh] overflow-y-auto" data-testid="sw-program-list">
          {visible.map((p) => (
            <li key={p.program_name}>
              <button
                type="button"
                onClick={() => onSelect(p.program_name)}
                className={`w-full text-left px-2 py-2 hover:bg-[var(--ml-primary)]/5 ${selected === p.program_name ? "bg-[var(--ml-primary)]/8 border-l-2 border-[var(--ml-primary)]" : "border-l-2 border-transparent"}`}
                data-testid={`sw-program-${p.program_name}`}
                data-steps={p.steps}
                aria-pressed={selected === p.program_name}
              >
                <div className="flex items-center justify-between gap-2">
                  <span className="ml-mono text-sm font-semibold">
                    {p.program_library && <span className="font-normal text-[var(--ml-text-secondary)]">{p.program_library}/</span>}{p.program_name}
                  </span>
                  <span className="ml-mono text-[10px] text-[var(--ml-text-secondary)] whitespace-nowrap">{p.steps} step{p.steps === 1 ? "" : "s"}</span>
                </div>
                <div className="text-[11px] text-[var(--ml-text-secondary)] mt-0.5 flex flex-wrap gap-x-2">
                  <span>{p.display_files?.length ? p.display_files.join(", ") : "no bound display file"}</span>
                  {p.ambiguous > 0 && <span style={{ color: "#8a6d00" }}>{p.ambiguous} ambiguous</span>}
                  {p.unresolved > 0 && <span>{p.unresolved} unresolved</span>}
                </div>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
